import { createSelector } from '@reduxjs/toolkit';
import { selectJsonQuery } from './selectJsonQuery';
import { getTermValue } from '../../../packages/JsonQuery';

export const selectPrepay = createSelector(selectJsonQuery, jsonQuery => getTermValue('prepay')(jsonQuery));
